import React, { useContext } from "react";
import { css } from "emotion";
import { colors, textSizes, boxStyles } from "../../styles/theme";
import { EditContext } from "../../context/EditSpotlightState";

const TabBar = () => {
  const { type, setType } = useContext(EditContext);

  const handleClick = (nextVal) => {
    setType(nextVal);
  };

  return (
    <div className={tabBar}>
      <button
        className={type === 'text' ? "active-tab" : ""}
        onClick={(e) => handleClick('text')}
      >
        Text
      </button>
      <button
        className={type === 'audio' ? "active-tab" : ""}
        onClick={(e) => handleClick('audio')}
      >
        Audio
      </button>
    </div>
  );
};

export default TabBar;

const tabBar = css`
  display: flex;
  justify-content: space-evenly;
  button {
    border: none;
    user-select: none;
    cursor: pointer;
    background-color: white;
    color: ${colors.placeholderText};
    font-size: ${textSizes.normal};
    padding: 10px 0 5px 0;
    text-decoration: none;
    flex: 1;
    text-align: center;
    border-bottom: 1px solid ${colors.placeholderText};
    font-weight: bold;
    transition-duration: 200ms;
  }
  .active-tab {
    border-bottom: 1px solid ${colors.brandColor};
    color: ${colors.titleColor};
  }

  @media screen and (min-width: ${boxStyles.desktopBreak}) {
    border-radius: ${boxStyles.borderRadius};
    background-color: ${colors.inputBackground};
    padding: 3px;
    width: 50%;
    button {
      border: none;
      background-color: transparent;
      border-radius: ${boxStyles.borderRadius};
      padding: 7px 0;
      margin: 0 2px;
      &:hover {
        background-color: white;
      }
    }
    .active-tab {
      border: none;
      background-color: white;
      color: ${colors.brandColor};
    }
  }
`;
